import { render, staticRenderFns } from "./PageManagementDetail.vue?vue&type=template&id=97f397e4&scoped=true"
import script from "./PageManagementDetail.vue?vue&type=script&lang=js"
export * from "./PageManagementDetail.vue?vue&type=script&lang=js"
import style0 from "./PageManagementDetail.vue?vue&type=style&index=0&id=97f397e4&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f397e4",
  null
  
)

export default component.exports